export default {
  setData(state, { payload }) {
    state.allData = payload.data.list;
  },
  setDataDetail(state, { payload }) {
    state.dataDetail = payload.data;
  },
  setItem(state, { payload }) {
    state.item = payload.data.data;
  },
  setApprovedStatus(state, payload) {
    state.approvedStatus = payload;
  },
  setCategory(state, data) {
    state.allCategory = data;
  },
  setFlashErrorMessage(state, payload) {
    state.flashErrorMessage = payload;
    state.flashError = payload !== '';
  },
  clearData(state) {
    state.allData = [];
    state.totalData = 0;
  },
  clearErrors(state) {
    state.errors = [];
  },
  setErrors(state, payload) {
    state.errors = payload;
  },
  setTotalData(state, { payload }) {
    state.totalData = parseInt(payload.data.count_data, 10);
    state.totalPage = parseInt(payload.data.total_page, 10);
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setInsertProgress(state, insertProgress) {
    state.insertProgress = insertProgress;
  },
  setIntervalExport(state, payload) {
    state.intervalExport = payload;
  },
  setExportData(state, payload) {
    state.exportId = payload.export_id;
    state.countDataExport = payload.count_data;
  },

  setStateVariable(state, { payload, variable }) {
    state[variable] = payload;
  },
  setCancelation(state, payload) {
    state.requestData = payload;
  },
  removeData(state, { index }) {
    state.totalData -= 1;
    state.allData = state.allData.filter((value) => value.id !== index);
  },
  setIntervalRefund(state, payload) {
    state.intervalRefund = payload;
  },
  setRefundData(state, payload) {
    state.refundId = payload.export_id;
    state.countDataRefund = parseInt(payload.count_data, 10);
  },
  setShowProgressBar(state, payload) {
    state.showProgressBar = payload;
  },
  setProgressTitle(state, title) {
    state.progressTitle = title;
  },
  setProgressColor(state, color) {
    state.progressColor = color;
  },
  setPercentage(state, percentage) {
    state.percentage = percentage;
  },
  setFailedResponse(state, payload) {
    state.isFailedResponse = payload;
  },

};
